import { render, staticRenderFns } from "./FormPercentageInput.vue?vue&type=template&id=06d3db37&scoped=true&"
import script from "./FormPercentageInput.vue?vue&type=script&lang=js&"
export * from "./FormPercentageInput.vue?vue&type=script&lang=js&"
import style0 from "./FormPercentageInput.vue?vue&type=style&index=0&id=06d3db37&prod&scoped=true&lang=css&"
import style1 from "./FormPercentageInput.vue?vue&type=style&index=1&id=06d3db37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d3db37",
  null
  
)

export default component.exports